export default __webpack_public_path__ + "static/media/gallery_five.93399683.jpg";